export const frCommon = {
  // ... existing translations ...
  "welcome": "Bienvenue chez GRUPO FR",
  "description": "Votre partenaire immobilier de confiance",
  "exploreProperties": "Explorer les Propriétés",
  "ourServices": "Nos Services",
  "featuredProperties": "Propriétés en Vedette",
  "aboutUs": "À Propos de Nous",
  "contactUs": "Nous Contacter",
  "allRights": "Tous droits réservés",
  "propertySales": "Vente de Propriétés",
  "propertyRentals": "Location de Propriétés",
  "propertyManagement": "Gestion de Propriétés",
  "realEstateConsulting": "Conseil Immobilier",
  "propertyValuation": "Évaluation de Propriétés",
  "legalSupport": "Support Juridique",
  "adminPanel": "Panneau d'Administration",
  "language": "Langue",
  
  // Search functionality
  "propertyType": "Type de Propriété",
  "location": "Emplacement",
  "status": "Statut",
  "forSale": "À Vendre",
  "forRent": "À Louer",
  "advancedSearch": "Recherche Avancée",
  "priceRange": "Gamme de Prix",
  "minPrice": "Prix Min.",
  "maxPrice": "Prix Max.",
  "bedrooms": "Chambres",
  "bathrooms": "Salles de Bain",
  "area": "Superficie",
  "minArea": "Superficie Min.",
  "any": "Tous",
  "reset": "Réinitialiser",
  "apartment": "Appartement",
  "house": "Maison",
  "condo": "Condo",
  "office": "Bureau",
  "commercial": "Commercial",
  
  // Compare functionality
  "compareProperties": "Comparer les Propriétés",
  "properties": "Propriétés",
  "characteristics": "Caractéristiques",
  "noPropertiesToCompare": "Aucune propriété à comparer",
  "selectPropertiesToCompare": "Sélectionnez des propriétés pour comparer leurs caractéristiques",
  "remove": "Supprimer",
  "yearBuilt": "Année de Construction",
  "parking": "Stationnement",
  "floor": "Étage",
  "furnished": "Meublé",
  "yes": "Oui",
  "no": "Non",
  "features": "Caractéristiques",
  "more": "plus",
  "comparingProperties": "Comparaison de {{count}} propriétés",
  "clearAll": "Tout Effacer",
  "close": "Fermer",
  "addToCompare": "Ajouter à la Comparaison",
  "removeFromCompare": "Retirer de la Comparaison",
  "compare": "Comparer",
  
  // Appointment booking
  "scheduleVisit": "Planifier une Visite",
  "contactInformation": "Informations de Contact",
  "fullName": "Nom Complet",
  "enterFullName": "Entrez votre nom complet",
  "email": "Email",
  "enterEmail": "Entrez votre email",
  "phone": "Téléphone",
  "enterPhone": "Entrez votre numéro de téléphone",
  "selectDateTime": "Sélectionner Date et Heure",
  "preferredDate": "Date Préférée",
  "selectDate": "Sélectionnez une date",
  "preferredTime": "Heure Préférée",
  "selectTime": "Sélectionnez une heure",
  "additionalMessage": "Message Supplémentaire",
  "optional": "optionnel",
  "enterAdditionalMessage": "Entrez toute demande spéciale ou question",
  "characters": "caractères",
  "importantInformation": "Informations Importantes",
  "visitDuration": "La durée de la visite est d'environ 30-45 minutes",
  "confirmationMessage": "Vous recevrez une confirmation par email et téléphone",
  "cancellationPolicy": "Vous pouvez annuler ou reprogrammer avec 24h de préavis",
  "cancel": "Annuler",
  "scheduling": "Planification...",
  "appointmentConfirmed": "Rendez-vous Confirmé !",
  "appointmentConfirmedMessage": "Votre visite a été programmée avec succès. Nous vous contacterons bientôt.",
  "appointmentDetails": "Détails du Rendez-vous",
  "property": "Propriété",
  "name": "Nom",
  "date": "Date",
  "time": "Heure",
  "closingAutomatically": "Cette fenêtre se fermera automatiquement...",
  "preferVoiceAssistance": "Préférez-vous planifier par voix ? Utilisez notre assistant intelligent",
  "talkWithAgent": "Parler avec l'Agent",
  "bookVisit": "Réserver une Visite"
};

export default frCommon;
